module.exports = __webpack_public_path__ + "static/amabilidad_1-b2715dc5b50f268488d8dc85851e1bcc.jpg";